// 英文
export default {
    public: {
        call:'Hello! ',
        logout: 'Log out',
        delSuccess:'Deletion successful',
        switching:'Switching to multiple languages successfully',
        login: 'Login/Register',
    },
    ykpHeader: {
        product: 'Product',
        productList: 'Product List',
        // 左侧产品相关
        allProducts: 'All Products',
        searchLiterature: 'Search Literature',
        readLiterature: 'Read Literature',
        writeLiterature: 'Write Literature',
        translateLiterature: 'Translate Literature',
        
        // 用户相关
        userProduct: 'User Product',
        personalCenter: 'Personal Center',
        problemFeedback: 'Problem Feedback',
        logout: 'Logout',
        
        // 问题反馈弹窗
        functionModule: 'Function Module:',
        selectModule: 'Please select the function module with issues',
        problemDescription: 'Problem Description:',
        enterDescription: 'Please enter problem description',
        problemScreenshot: 'Problem Screenshot:',
        email: 'Email:',
        enterEmail: 'Please enter email',
        cancel: 'Cancel',
        submit: 'Submit',
        feedbackSuccess: 'Problem feedback submitted successfully!',
        
        // 登录相关
        loginType: 'Login Type',
        confirm: 'Confirm',
        pleaseLogin: 'Please login first',
        loginExpired: 'Login has expired',
        pleaseUsePersonalAccount: 'Please use personal account to login',
        
        // 表单验证
        pleaseSelectModule: 'Please select function module',
        pleaseEnterDescription: 'Please enter problem description',
        pleaseEnterEmail: 'Please enter email'
    },
}